export function PageHeader({ overline, title, subtitle, action }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4">
      <div className="min-w-0">
        {overline && <div className="text-xs tracking-[0.2em] uppercase font-bold text-accent">{overline}</div>}
        <h1 className="font-display font-black text-3xl md:text-4xl text-primary mt-1">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function SectionTitle({ children, icon: Icon, right }) {
  return (
    <div className="flex items-center justify-between gap-3 mb-3">
      <div className="flex items-center gap-2">
        {Icon && <Icon size={18} weight="duotone" className="text-accent" />}
        <h3 className="font-display text-lg md:text-xl font-semibold text-primary">{children}</h3>
      </div>
      {right}
    </div>
  );
}

export function EmptyState({ children, icon: Icon }) {
  return (
    <div className="rounded-lg border border-dashed border-border bg-white/60 py-12 px-6 text-center" data-testid="empty-state">
      {Icon && <Icon size={30} weight="duotone" className="mx-auto mb-2 text-muted-foreground" />}
      <div className="text-sm text-muted-foreground">{children}</div>
    </div>
  );
}

export function Stat({ label, value, tone = "text-primary", sub, testid }) {
  return (
    <div className="rounded-lg border border-border bg-white p-4" data-testid={testid}>
      <div className="text-[11px] tracking-[0.15em] uppercase text-muted-foreground">{label}</div>
      <div className={`font-display font-black text-2xl mt-1 tabular ${tone}`}>{value}</div>
      {sub && <div className="text-xs text-muted-foreground mt-0.5">{sub}</div>}
    </div>
  );
}
